import React, { useState } from 'react';
import { Building2, ChevronRight, BarChart3, Users, Target, TrendingUp } from 'lucide-react';
import RegistrationForm from './components/RegistrationForm';
import MetricsForm from './components/MetricsForm';

function App() {
  const [showForm, setShowForm] = useState(false);
  const [showMetrics, setShowMetrics] = useState(false);

  if (showMetrics) {
    return <MetricsForm />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10" />
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16 relative">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Análise Gratuita para seu
              <span className="text-blue-600"> Escritório de Arquitetura</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Descubra insights valiosos sobre seu negócio e tome decisões baseadas em dados para impulsionar seu crescimento.
            </p>
            <button
              onClick={() => setShowForm(true)}
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg shadow-lg hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 group"
            >
              Quero uma análise gratuita
              <ChevronRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
            </button>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <BenefitCard
            icon={<BarChart3 className="h-8 w-8 text-blue-600" />}
            title="Métricas Detalhadas"
            description="Análise completa do desempenho do seu escritório"
          />
          <BenefitCard
            icon={<Users className="h-8 w-8 text-blue-600" />}
            title="Insights de Mercado"
            description="Compare seu desempenho com o mercado"
          />
          <BenefitCard
            icon={<Target className="h-8 w-8 text-blue-600" />}
            title="Objetivos Claros"
            description="Defina metas realistas baseadas em dados"
          />
          <BenefitCard
            icon={<TrendingUp className="h-8 w-8 text-blue-600" />}
            title="Crescimento"
            description="Estratégias personalizadas para crescer"
          />
        </div>
      </div>

      {/* Registration Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <RegistrationForm onClose={() => {
            setShowForm(false);
            setShowMetrics(true);
          }} />
        </div>
      )}
    </div>
  );
}

function BenefitCard({ icon, title, description }: { icon: React.ReactNode; title: string; description: string }) {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
      <div className="mb-4">{icon}</div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
}

export default App;